/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { statusMessages as messages } from '@atlaskit/editor-common/messages';
import { fg } from '@atlaskit/platform-feature-flags';
import { Status } from '@atlaskit/status/element';
var styledStatusStyles = css({
  opacity: 1
});
var styledStatusPlaceholderStyles = css({
  opacity: 0.5
});
var StatusContainerView = function StatusContainerView(props) {
  var text = props.text,
    color = props.color,
    localId = props.localId,
    style = props.style,
    formatMessage = props.intl.formatMessage;
  var statusText = text ? text : formatMessage(messages.placeholder);
  var handleClick = function handleClick(event) {
    if (event.nativeEvent.stopImmediatePropagation) {
      event.nativeEvent.stopImmediatePropagation();
    }
    // handling of popup is done in plugin.apply on selection change.
  };
  return jsx("span", {
    css: text ? styledStatusStyles : styledStatusPlaceholderStyles,
    "data-testid": "statusContainerView"
  }, jsx(Status, {
    text: statusText,
    color: color,
    localId: localId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    onClick: handleClick,
    isBold: fg('platform-component-visual-refresh')
  }));
};
export var IntlStatusContainerView = injectIntl(StatusContainerView);
export var StatusNodeView = function StatusNodeView(props) {
  var view = props.view;
  var _props$node$attrs = props.node.attrs,
    text = _props$node$attrs.text,
    color = _props$node$attrs.color,
    localId = _props$node$attrs.localId,
    style = _props$node$attrs.style;
  return jsx(IntlStatusContainerView, {
    view: view,
    text: text,
    color: color
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    localId: localId
  });
};